import styled from 'styled-components'
import { font, colors, spacing } from '@chegg-ui/theme'
import { SecondaryButton } from '@chegg-ui/button'

export const SmallNotificationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.skyXlight};
  font-family: ${font.family.default};
  min-height: 2.75rem;
`

/**
 * [1]: keep button hit box big and have consistent visual spacing
 */
export const SignInCTA = styled(SecondaryButton)`
  white-space: nowrap;
  font-size: 1rem;
  margin-right: -${spacing.px8}; /* [1] */
  padding-left: ${spacing.px8}; /* [1] */
  padding-right: ${spacing.px8}; /* [1] */
`
